export const MODELS = [
  { id: "claude-opus-4-6", label: "Opus 4.6", note: "Premium" },
  { id: "claude-sonnet-4-5-20250929", label: "Sonnet 4.5", note: "Most capable" },
  { id: "claude-sonnet-4-20250514", label: "Sonnet 4", note: "Fast" },
  { id: "claude-haiku-4-5-20251001", label: "Haiku 4.5", note: "Fastest" },
];

export const MODEL_STORAGE_KEY = "intellitools-preferred-model";
export const DEFAULT_MODEL = "claude-sonnet-4-5-20250929";

export const getSavedModel = () => {
  try {
    const saved = localStorage.getItem(MODEL_STORAGE_KEY);
    if (saved && MODELS.some(m => m.id === saved)) return saved;
  } catch {}
  return DEFAULT_MODEL;
};

export const getMaxTokens = (modelId, fallback) => {
  const m = MODELS.find(m => m.id === modelId);
  return m?.maxTokens ? Math.min(m.maxTokens, fallback) : fallback;
};

export const getModelLabel = (modelId) => {
  const found = MODELS.find(m => m.id === modelId);
  return found ? found.label : modelId;
};
